import module from '../module';
import Constants from '../../../utils/CommonConstants';

class SquareUpPaymentFormDirectiveController {

    constructor(scope) {

        this._scope = scope;

        scope.$watch('visible', visible => {
            if (visible) {
                this._paymentForm = new SqPaymentForm({
                    applicationId: Constants.SQUARE_UP_APPLICATION_ID,
                    inputClass: 'sq-input',
                    inputStyles: [
                        {
                            fontSize: '14px'
                        }
                    ],
                    cardNumber: {
                        elementId: 'sq-card-number'
                    },
                    cvv: {
                        elementId: 'sq-card-cvv'
                    },
                    expirationDate: {
                        elementId: 'sq-card-date'
                    },
                    postalCode: {
                        elementId: 'sq-card-postal-code'
                    },
                    callbacks: {
                        cardNonceResponseReceived: this._onCardNonceResponseReceived.bind(this)
                    }
                });
                this._paymentForm.build();
            }
        });

        scope.$on('$destroy', () => {
            if (this._paymentForm) {
                this._paymentForm.destroy();
            }
        });

        scope.nonce = () => {
            return new Promise((resolve, reject) => {
                this._nonceCallback = (errors, nonce, cardData) => {
                    this._nonceCallback = null;
                    if (errors) {
                        reject(errors);
                        return;
                    }

                    resolve({
                        nonce,
                        cardData
                    });
                };
                this._paymentForm.requestCardNonce();
            });
        };
    }

    _onCardNonceResponseReceived(errors, nonce, cardData) {
        this._nonceCallback(errors, nonce, cardData);
    }
}

module.directive('squareUpPaymentForm', function () {
    return {
        scope: {
            nonce: '=',
            visible: '='
        },
        templateUrl: 'modules/shared/views/squareUpPaymentForm.html',
        link: function ($scope, element) {
            new SquareUpPaymentFormDirectiveController($scope, element);
        }
    };
});



// WEBPACK FOOTER //
// ./src/modules/shared/directives/SquareUpPaymentForm.js